// extracted by mini-css-extract-plugin
export default {"container":"SupportScreen_container__jKkvO","center_align":"SupportScreen_center_align__Ro1jX"};